import { HostMessageType } from '../../interfaces/host-message-types';
import { sendMessageToHost } from '../base/models/base-message';
import { MessageHandler } from '../base/interfaces/message.interface';
import { ViewerErrorPayload } from './interfaces/viewer-error-payload.interface';
import { isNonNullObject } from 'utilities';

export const ViewerErrorMessage: MessageHandler<ViewerErrorPayload> = {
  send(payload: ViewerErrorPayload, targetOrigin = '*'): void {
    sendMessageToHost(HostMessageType.ViewerError, payload, targetOrigin);
  },

  validatePayload(payload: unknown): payload is ViewerErrorPayload {
    return (
      isNonNullObject(payload) &&
      'viewerId' in payload &&
      typeof payload.viewerId === 'string' &&
      'error' in payload &&
      typeof payload.error === 'string' &&
      (!('code' in payload) || typeof payload.code === 'string')
    );
  },
};
